import React from 'react';
import { Button } from "react-bootstrap";
import { HoverBox } from '../../../components/fullTextOnHover/HoverBox';
import CaseListToolTip from '../../caselist_redux/caseListTable/CaseListTooltip'
import { StyledKfTable } from './../../../Styling/styledTable/StyledTable';
import styled from 'styled-components';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;


const FakturaTableAI = (props) => {

    const localeMessages = props.messages

    const convertDateFormat = (dateStr) => {
        if (!dateStr) return '';
        
        if (dateStr.includes('.')) {
          const parts = dateStr.split('.');
          if (parts.length !== 3) return '';
          const [day, month, year] = parts;
          return `${year}-${month}-${day}`;

        } else if (dateStr.includes('-')) {
            const parts = dateStr.split('-');
            if (parts.length !== 3) return '';
            const [year, month, day] = parts;
            return `${year}-${month}-${day}`;
        } else {
          return '';
        }
      };

    return (
        <TableWrapper>
            <StyledKfTable>
                <thead>
                    <tr>
                        <th>{localeMessages['fg_linje']}</th>
                        <th>{localeMessages['fg_fnr']}</th>
                        <th>{localeMessages['fg_fdato']}</th>
                        <th>{localeMessages['fg_forf']}</th>
                        <th>{localeMessages['fg_tekst']}</th>
                        <th>{localeMessages['fg_vedlegg']}</th> 
                        <th>{localeMessages['fg_kid']}</th>
                        <th>{localeMessages['fg_val']}</th>
                        <th>{localeMessages['fg_bel']}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    {props.fakturaListe.map((row, i) =>
                        <tr key={i}>
                            <td>{row.lineNo}</td>
                            <td><Button variant="link" size="lg" onClick={() => props.editFaktura(row.lineNo)}>{row.fakturaNummer}</Button></td>
                            <td>{convertDateFormat(row.fakturaDato)}</td>
                            <td>{convertDateFormat(row.forfallsDato)}</td>
                            <td><HoverBox minWidth={150}>{row.fakturaTekst}</HoverBox></td>
                            <td><HoverBox>{row.fileName}</HoverBox></td>                        
                            <td>{row.kid}</td>
                            <td>{row.valuta}</td>
                            <td align="right">{row.belop.toFixed(2).replace('.', ',')}</td>
                            <td>
                                <CaseListToolTip id={i} caption={localeMessages['fg_edit'] + row.fakturaNummer}>
                                    <span className="fa fa-edit"
                                        onClick={
                                            () => {
                                                props.editFaktura(row.lineNo)
                                            }
                                        } />
                                </CaseListToolTip>
                                &nbsp;


                                <CaseListToolTip id={i} caption={localeMessages['fg_slett'] + row.fakturaNummer}>
                                    <span className="fa fa-trash"
                                        onClick={
                                            () => {
                                                props.deleteFaktura(row.lineNo)
                                            }
                                        } />
                                </CaseListToolTip>
                                &nbsp;


                            </td>
                        </tr>
                    )}
                </tbody>
            </StyledKfTable>
        </TableWrapper>
    )
}

export default FakturaTableAI